export default "__VITE_ASSET__QZhD8VKs__"